export enum CandidatureAddRequestCandidatureEntryType {
  CREATE_SOLVED_ORDER = "CREATE_SOLVED_ORDER",
  DELETE_SOLVED_ORDER = "DELETE_SOLVED_ORDER",
  CREATE_PLAN_ENTRY = "CREATE_PLAN_ENTRY",
}

export type CandidatureAddRequestCandidatureCreatePlanEntry = {
  candidateEntryType: CandidatureAddRequestCandidatureEntryType.CREATE_PLAN_ENTRY;
  transportingOrderId?: string;
  taxiCorporationId?: string;
  givenPlanEntryId?: string;
  candidatingSolve: string;
};

export type CandidatureAddRequestCandidatureCreateSolvedOrderEntry = {
  candidateEntryType: CandidatureAddRequestCandidatureEntryType.CREATE_SOLVED_ORDER;
  planEntryId?: string;
  createPlanEntryId?: string;
  transportingOrderId: string;
  candidatingSolve: string;
};

export type CandidatureAddRequestCandidatureDeleteSolvedOrderEntry = {
  candidateEntryType: CandidatureAddRequestCandidatureEntryType.DELETE_SOLVED_ORDER;
  deleteTargetId: string;
};

export type CandidatureAddRequestCandidatureEntry =
  | CandidatureAddRequestCandidatureCreatePlanEntry
  | CandidatureAddRequestCandidatureCreateSolvedOrderEntry
  | CandidatureAddRequestCandidatureDeleteSolvedOrderEntry;

export type CandidatureAddRequestBody = {
  candidateEntries: CandidatureAddRequestCandidatureEntry[];
  driverId: string;
  acceptImmediately?: boolean;
};

type CandidatureAddRequest = {
  candidatureEntries: CandidatureAddRequestCandidatureEntry[];
  driverId: string;
  acceptImmediately?: boolean;
};

export default CandidatureAddRequest;
